export let fromRefiner_SearchPlaceholder = "hWHcxd";
export let fromRefiner_RemovePerson = "feL3Xc";
export let fromRefiner_ClearSearch = "$AIoWc";
export let fromRefiner_Suggestions = "nTZ$g";
export let fromRefiner_Loading = "opD5od";
export let fromRefiner_NoSuggestions = "STPGKe";
export let fromRefiner_SelectedPerson = "GEX_6d";
export let fromRefiner_SelectedCount = "odyJY";
export default {fromRefiner_SearchPlaceholder,fromRefiner_RemovePerson,fromRefiner_ClearSearch,fromRefiner_Suggestions,fromRefiner_Loading,fromRefiner_NoSuggestions,fromRefiner_SelectedPerson,fromRefiner_SelectedCount};